import React from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Membros from "./pages/Membros";
import MembroForm from "./pages/MembroForm";
import Financeiro from "./pages/Financeiro";
import EBD from "./pages/EBD";
import Igrejas from "./pages/Igrejas";
import Configuracoes from "./pages/Configuracoes";
import Cargos from "./pages/Cargos";
import CargoForm from "./pages/CargoForm";
import EbdLogin from "./pages/EbdLogin";
import EBDLayout from "./components/EBDLayout";
import EbdApresentacao from "./pages/EbdApresentacao";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-sky-500"></div>
      </div>
    );
  }
  
  return isAuthenticated ? <Layout>{children}</Layout> : <Navigate to="/login" />;
};

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-sky-500"></div>
      </div>
    );
  }
  
  return !isAuthenticated ? children : <Navigate to="/dashboard" />;
};

const PublicEbdRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-sky-500"></div>
      </div>
    );
  }

  return !isAuthenticated ? children : <Navigate to="/ebd" replace />;
};

const PrivateEbdRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-sky-500"></div>
      </div>
    );
  }

  return isAuthenticated ? <EBDLayout>{children}</EBDLayout> : <Navigate to="/ebd/login" replace />;
};

/** EBD: tela cheia (ex.: apresentação), sem barra do layout */
const PrivateEbdFullscreenRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-sky-500" />
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/ebd/login" replace />;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
      <Route path="/ebd/login" element={<PublicEbdRoute><EbdLogin /></PublicEbdRoute>} />

      {/* Private Routes */}
      <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/membros" element={<PrivateRoute><Membros /></PrivateRoute>} />
      <Route path="/membros/novo" element={<PrivateRoute><MembroForm /></PrivateRoute>} />
      <Route path="/membros/:id" element={<PrivateRoute><MembroForm /></PrivateRoute>} />
      <Route path="/membros/:id/editar" element={<PrivateRoute><MembroForm /></PrivateRoute>} />
      <Route path="/financeiro" element={<PrivateRoute><Financeiro /></PrivateRoute>} />
      <Route path="/ebd" element={<PrivateEbdRoute><EBD /></PrivateEbdRoute>} />
      <Route
        path="/ebd/apresentacao"
        element={
          <PrivateEbdFullscreenRoute>
            <EbdApresentacao />
          </PrivateEbdFullscreenRoute>
        }
      />
      <Route path="/igrejas" element={<PrivateRoute><Igrejas /></PrivateRoute>} />
      <Route path="/cargos" element={<PrivateRoute><Cargos /></PrivateRoute>} />
      <Route path="/cargos/novo" element={<PrivateRoute><CargoForm /></PrivateRoute>} />
      <Route path="/cargos/:id/editar" element={<PrivateRoute><CargoForm /></PrivateRoute>} />
      <Route path="/configuracoes" element={<PrivateRoute><Configuracoes /></PrivateRoute>} />
      
      {/* Default Route */}
      <Route path="/" element={<Navigate to="/dashboard" />} />
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
